export const dishes = [
    '3979',
    '3092',
    '3980',
    '1493',
    '4443',
    '5331',
];

export const periodsForSelection = [
    '2026-03-16',
    '2026-03-23',
    '2026-03-30',
];

export const periods = [
    '2026-04-06',
    '2026-04-16',
    '2026-04-23',
    '2026-04-30',
];
